import { render, staticRenderFns } from "./FacetLists.vue?vue&type=template&id=e4a4b3e0&"
import script from "./FacetLists.vue?vue&type=script&lang=js&"
export * from "./FacetLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports